import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import RootStoreProvider from "./components/RootStore/RootStoreProvider";
import RootStore from "./stores/RootStore";
import { ThemeProvider } from "@mui/material/styles";
import DialogProvider from "components/Dialog/DialogProvider";
import { NotificationProvider } from "components/NotificationProvider";

export function renderApp(rootStore: RootStore): void {
  const container = document.getElementById("root");
  if (container) {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <RootStoreProvider rootStore={rootStore}>
          <ThemeProvider theme={rootStore.themeStore.currentTheme}>
            <DialogProvider>
              <NotificationProvider>
                <App />
              </NotificationProvider>
            </DialogProvider>
          </ThemeProvider>
        </RootStoreProvider>
      </React.StrictMode>
    );
  } else {
    console.error("Root container not found");
  }
}
